"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidationRules = exports.CellValidationState = exports.RowValidationState = void 0;
const debug_1 = __importDefault(require("debug"));
const _ = __importStar(require("lodash"));
const vee_validate_1 = require("vee-validate");
const log = (0, debug_1.default)('itp:ui:validation');
class RowValidationState {
    invalid;
    validated;
    fields;
    constructor(row, columns) {
        this.fields = this.createFields(row, columns);
        this.invalid = null;
        this.validated = false;
    }
    get valid() {
        return this.invalid == null ? null : this.invalid === false;
    }
    createFields(row, columns) {
        const result = new Map();
        for (let col of columns) {
            if (!col.systemColumn) {
                result.set(col.name, new CellValidationState(row[col.field], col.validationRules));
            }
        }
        return result;
    }
    async validate() {
        for (let field of this.fields.values()) {
            await field.validate();
        }
        this.updateStates();
        log('validate - valid: %s; invalid: %s', this.invalid === false, this.invalid);
        return this;
    }
    async validateField(name, value) {
        const field = this.fields.get(name);
        if (!field) {
            throw new Error(`Missing field state: ${name}`);
        }
        field.syncValue(value);
        await field.validate();
        this.updateStates();
        log('validateField[%s] - valid: %s (%s) - value: %o', name, field.valid, field.errorMessage, value);
        return field;
    }
    getCellState(name) {
        const field = this.fields.get(name);
        if (!field) {
            throw new Error(`Missing field state: ${name}`);
        }
        return field;
    }
    updateStates() {
        let invalid = false;
        for (let field of Object.values(this.fields)) {
            if (field.valid === false) {
                invalid = true;
                break;
            }
        }
        this.invalid = invalid;
        this.validated = true;
    }
}
exports.RowValidationState = RowValidationState;
class CellValidationState {
    valid;
    errorMessage;
    values;
    rules;
    constructor(value, rules) {
        this.valid = null;
        this.values = [value];
        this.rules = rules;
        this.errorMessage = null;
    }
    syncValue(value) {
        this.values.push(value);
    }
    async validate() {
        const value = this.values[this.values.length - 1];
        const result = await (0, vee_validate_1.validate)(value, this.rules);
        this.valid = result.valid;
        this.errorMessage =
            result.errors && result.errors.length ? result.errors.join(' ') : null;
    }
    get changed() {
        return (this.values.length > 1 && !_.isEqual(this.values[0], _.last(this.values)));
    }
}
exports.CellValidationState = CellValidationState;
function getValidationRules(...validators) {
    const rules = {};
    for (let v of validators) {
        if (!v) {
            continue;
        }
        if (_.isString(v)) {
            v = v.split(';');
        }
        if (_.isArray(v)) {
            if (!v.length) {
                continue;
            }
            addRulesFromStringArray(v, rules);
            continue;
        }
        if (_.isObject(v)) {
            addRulesFromObject(v, rules);
            continue;
        }
    }
    return rules;
}
exports.getValidationRules = getValidationRules;
function addRulesFromStringArray(values, rules) {
    const validators = [];
    for (let item of values) {
        const idx = item.indexOf(':');
        if (idx > 0) {
            validators.push([item.substring(0, idx), item.substring(idx + 1)]);
        }
        else {
            validators.push([item, '']);
        }
    }
    for (let [name, args] of validators) {
        addRule(name, args, rules);
    }
    return rules;
}
function addRulesFromObject(values, rules) {
    for (let [name, args] of Object.entries(values)) {
        if (args === false) {
            continue;
        }
        addRule(name, args, rules);
    }
    return rules;
}
function addRule(name, args, rules) {
    switch (name) {
        case 'required':
            rules.required = true;
            break;
        case 'min':
        case 'minLength':
            rules.min = args;
            break;
        case 'minValue':
            rules.min_value = args;
            break;
        case 'max':
        case 'maxLength':
            rules.max = args;
            break;
        case 'maxValue':
            rules.max_value = args;
            break;
        case 'numeric':
            rules.numeric = true;
            break;
        case 'double':
            if (args === true) {
                rules.double = true;
                return;
            }
            if (_.isObject(args)) {
                rules.double = args;
            }
            else {
                let params = (args || '').split(',');
                rules.double = {
                    decimals: _.get(params, 0, 0),
                    separator: _.get(params, 1, '.')
                };
            }
            break;
        case 'in':
            rules.oneOf = args.split('|');
            break;
        case 'regex':
            rules.regex = args;
            break;
        case 'starts':
        case 'ends':
        case 'regex':
        case 'unique':
            throw new Error(`Validator ${name} not implemented`);
    }
}
//# sourceMappingURL=validation.js.map